import { render } from "./AccessDenied.vue?vue&type=template&id=b0067b56"
import script from "./AccessDenied.vue?vue&type=script&lang=ts"
export * from "./AccessDenied.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
